<template>
  <a class="btn btn-secondary" @click="openSupplies({product: product})">Zum Zubehör</a>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      openSupplies: 'supplies/openSupplies'
    })
  }
}
</script>
